import React from "react";
import UnclaimButton from "@components/FlowActionButtons/UnclaimButton";
import type { VendorLicenseTask } from "@services/licensing/types";
import { useUnclaimLicense } from "./hooks";
import { canUserUnclaim } from "./utils";

type LicenseFlowData = {
  id: string;
  status: string;
  task: VendorLicenseTask | null;
};

interface UnclaimLicenseProps {
  refetchLicense: () => Promise<unknown> | void;
  licenseFlowData?: LicenseFlowData;
  isPortOperatorContext?: boolean;
}

const LANG_BASE = "licensing";

const UnclaimLicense: React.FC<UnclaimLicenseProps> = ({
  licenseFlowData,
  refetchLicense,
  isPortOperatorContext = false,
}) => {
  const { onUnclaimLicense } = useUnclaimLicense(
    licenseFlowData?.id,
    refetchLicense,
    isPortOperatorContext,
  );

  if (!licenseFlowData || !licenseFlowData.task) return null;

  const isActionAvailable = canUserUnclaim(
    licenseFlowData.task.status,
    licenseFlowData.task.claimOwnerName,
  );

  return (
    <UnclaimButton
      langBase={LANG_BASE}
      permission={["canUnclaimPortOperatorLicense", "canUnclaimVendorLicense"]}
      isActionAvailable={isActionAvailable}
      onUnclaim={onUnclaimLicense}
    />
  );
};

export default UnclaimLicense;
